import React from 'react';
import PropTypes from 'prop-types';

const Appearances = props => {

    const { appearances } = props;

    return (
        <article className="mt-3 mb-4 text-center">
            <span className="text-team">{appearances}</span>
        </article>
    )
}

export default Appearances

Appearances.propTypes = {
    appearances: PropTypes.string.isRequired 
}